import { __ } from '@wordpress/i18n';
import React from 'react';

// components
import VerticalBarChart from '../../../../components/VerticalBarChart';

const WidgetEarningsTotal = () => {
    const data = [
        { name: 'Gen', value: 3200 },
        { name: 'Feb', value: 4100 },
        { name: 'Mar', value: 5800 },
        { name: 'Apr', value: 2900 },
        { name: 'Mag', value: 3700 },
        { name: 'Giu', value: 4500 },
        { name: 'Lug', value: 3100 },
        { name: 'Ago', value: 2200 },
        { name: 'Set', value: 3900 },
        { name: 'Ott', value: 5400 }
    ];

    return(
        <div className="appDashboard__widget">
            <VerticalBarChart
                data={data}
                title={__('Guadagni totali', 'soundbetween')}
                totalValue={0}
                height={90}
            />
        </div>
    )
}

export default WidgetEarningsTotal;